import { Typography } from '@mui/material';
import React from 'react';
import Jobs from '../../../components/Contractors/Owner/Jobs';

const ContractorJobList = () => {
    return (
        <div>
            <Typography variant='h1'>Job List</Typography>
            <Jobs />
        </div>
    );
};

export default ContractorJobList;
